import types from '../../types';

const tokens = (state = { loading: true, data: null }, { type, payload }) => {
  switch (type) {
    case types.GET_TOKENS_START:
      return { ...state, loading: true };

    case types.GET_TOKENS_SUCCESS:
      return { data: payload, loading: false };

    case types.GET_TOKENS_FAILURE:
      return { ...state, loading: false };

    default:
      return state;
  }
};

export default tokens;
